(function () {
    'use strict';
    angular
        .module('app.performanceInteractionReport')
        .directive('performanceInteractionReportDirective', function () {
                return {
                    controller: 'performanceInteractionReportCtrl',
                    templateUrl: 'app/measure/performanceReport/interactionReport/interactionReport.html?app_v=deployDate',
                    restrict: 'E',
                    scope: {
                    },
                    replace: true,
                    transclude: true
                };
            })
})();